import { render } from "./ThreeScene.vue?vue&type=template&id=53f0e98c&scoped=true&ts=true"
import script from "./ThreeScene.vue?vue&type=script&lang=ts"
export * from "./ThreeScene.vue?vue&type=script&lang=ts"

import "./ThreeScene.vue?vue&type=style&index=0&id=53f0e98c&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f0e98c"]])

export default __exports__